import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

/*
    getUnregisteredUserInfo() returns like this:
      {
        email: "testgg2345@els.test",
        firstName: "two",
        gui: "3cda8cbc-1f36-4bf2-801f-6e2f03abee06",
        hideTCs: false,
        interfaceLanguage: "en-US",
        lastName: "testTwo",
        status: "UNREGISTERED"
      }
    unless the org is suspended in which case it is like this:
      {
        gui: "3cda8cbc-1f36-4bf2-801f-6e2f03abee06",
        status: "suspended_org"
      }
    or if the user is already registered, like this:
      {
        gui: "3cda8cbc-1f36-4bf2-801f-6e2f03abee06",
        status: "NOT_REGISTERABLE"
      }
 */
export const getUnregisteredUserInfo = (userId) => {
  const egoUrl = envConfigs.egoApiHost + '/api/users/' + userId + '/registration';
  return fetch(egoUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache'
    }
  }).then((response) => {
    return handleServiceCall(response).then((userInfo) => {
      return userInfo;
    });
  });
};

export const registerUserWithEgo = (userId, registrationInfo) => {
  const egoUrl = envConfigs.egoApiHost + '/api/users/' + userId + '/registration';
  const postString = JSON.stringify(registrationInfo);
  return fetch(egoUrl, {
    method: 'POST',
    body: postString,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Accept: 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};



// WEBPACK FOOTER //
// ./src/modules/register/services/register-helpers.js